var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileDownloadUrl)?_c('a',{staticClass:"text-dense",attrs:{"href":_vm.fileDownloadUrl,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.fileName)+" ")]):_c('span',[_vm._v(_vm._s(_vm.displayValue))])}
var staticRenderFns = []

export { render, staticRenderFns }